/**
 * Cookie 工具函数
 *
 * 提供 Cookie 的设置、获取和删除功能
 */

const COOKIE_PATH = '/';

/**
 * 设置 Cookie
 *
 * @param name - Cookie 名称
 * @param value - Cookie 值
 * @param days - 有效期（天数）
 */
export function setCookie(name: string, value: string, days: number): void {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);

  const cookieValue = [
    `${name}=${encodeURIComponent(value)}`,
    `expires=${expires.toUTCString()}`,
    `path=${COOKIE_PATH}`,
    'sameSite=lax',
  ].join('; ');

  document.cookie = cookieValue;
}

/**
 * 获取 Cookie
 *
 * @param name - Cookie 名称
 * @returns Cookie 值，不存在返回 null
 */
export function getCookie(name: string): string | null {
  const nameEQ = `${name}=`;
  const cookies = document.cookie.split(';');

  for (const cookie of cookies) {
    let c = cookie;
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(nameEQ) === 0) {
      return decodeURIComponent(c.substring(nameEQ.length));
    }
  }

  return null;
}

/**
 * 删除 Cookie
 *
 * @param name - Cookie 名称
 */
export function deleteCookie(name: string): void {
  document.cookie = `${name}=;expires=${new Date(0).toUTCString()};path=${COOKIE_PATH}`;
}
